import { render } from "./StandAloneAccountability.vue?vue&type=template&id=c76c366a&scoped=true"
import script from "./StandAloneAccountability.vue?vue&type=script&lang=js"
export * from "./StandAloneAccountability.vue?vue&type=script&lang=js"

import "./StandAloneAccountability.vue?vue&type=style&index=0&id=c76c366a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c76c366a"]])

export default __exports__